module.exports = __webpack_public_path__ + "static/media/volantino.3cde894a.svg";